import { render, staticRenderFns } from "./ChapterSubResult.vue?vue&type=template&id=14447314&"
import script from "./ChapterSubResult.vue?vue&type=script&lang=js&"
export * from "./ChapterSubResult.vue?vue&type=script&lang=js&"
import style0 from "./ChapterSubResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports